var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9ffe8c008119fdb2c763d3ddba63eaa01c1eddfd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cocktail-inabox@hardpixel"]={id:"9ffe8c008119fdb2c763d3ddba63eaa01c1eddfd"};
      